import { useSelector } from 'react-redux'

import { selectors } from 'store/selectors'

export const useIsInFavorites = (productCode: string) => {
	const favoriteProducts = useSelector(selectors.favorites)
	const isInFavorites = favoriteProducts.includes(productCode)

	return isInFavorites
}
